import React, { FunctionComponent } from 'react';
import { Wrapper } from './Header.styled';
import { headerMapping } from './Header.constants';
import { Text, Icon } from 'bohr-web';
import Logo from '../../../Icons/svg/logo.svg';

const Header: FunctionComponent<any> = () => {
  return (
    <Wrapper>
      <Icon path={Logo} alt="" height="60px" width="60px" />
      <Text
        text={headerMapping(window.location.pathname)}
        size="header1"
        variant="semiBold"
        referenceClass="header-text"
      />
    </Wrapper>
  );
};

export default Header;
